import { render, staticRenderFns } from "./HtmlEditorWithMentions.vue?vue&type=template&id=d2186a30&scoped=true&"
import script from "./HtmlEditorWithMentions.vue?vue&type=script&lang=js&"
export * from "./HtmlEditorWithMentions.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditorWithMentions.vue?vue&type=style&index=0&id=d2186a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2186a30",
  null
  
)

export default component.exports